module.exports = new __parcel__URL__("Isdalen_premium_ICECREAM_CMYK_positiv.a831ef3e.svg").toString();